import React, { useState } from 'react'
import AddIcon from '@material-ui/icons/Add'
import ClearIcon from '@material-ui/icons/Clear'
import { Grid, Link, IconButton, ButtonBase } from '@material-ui/core'
import messages from '../../../../messages'
import { FormattedMessage } from 'react-intl'
import { ConfigContext } from '../../Genomics'
import DeleteDialog from '../../../../components/DeleteDialog'
import { useRouter, genomicsRoute } from '@src/routes'
import { ActiveLinkType, GenomicsProperties } from '../../enum'
import { useCustomCrisprSaveToSessionMutation } from '@src/mutations/ConfiguratorTubesMutation.generated'
import { useGetCrisprPriceCallLazyQuery } from '@src/queries/ConfiguratorTubesQuery.generated'
import { priceFormatter } from '@src/routes/Configurators/utils/PriceFormatter'
import styles from '@src/routes/Configurators/utils/styles'
import ViewCrisprItem from '../../ViewCrisprItem/ViewCrisprItem'
import { ConfiguratorValues } from '@src/routes/Configurators/utils/constants'
import CircleLoader from '@src/components/CircleLoader'
import DataTable from '@src/routes/Configurators/components/DataTable'
import { ConfirmOrderTableProps } from '@src/routes/Configurators/components/ConfiguratorTypes'
import {
  ListSubModel,
  ConfiguratorProductInput,
} from '@src/types/graphql-types'
import PerformanceGuaranteeModal from '@src/routes/Configurators/components/PerformanceGuaranteeModal'

const ConfirmOrderTable = ({
  productDetails,
  currencyFormat,
  thousandSeparator,
  thousandSpacing,
  prefixCurrecny,
  decimalSeparator,
}: ConfirmOrderTableProps) => {
  const { state, dispatch } = React.useContext(ConfigContext)
  const { sessionData, currentSubModelIndex, customCrisprIndex } = state
  const [delDialogOpen, setDelDialogOpen] = useState<boolean>(false)
  const [dialogOpen, setDialogOpen] = useState<boolean>(false)
  const [delItem, setDelItem] = useState()
  const [viewItem, setViewItem] = useState<ListSubModel>()
  const [viewItemIndex, setViewItemIndex] = useState<number>(0)
  const [delType, setDelType] = useState<string>('')
  const handleDelete = (item) => {
    setDelDialogOpen(true)
    setDelType('Selected')
    setDelItem(item)
  }
  const router = useRouter()
  const globalClasses = styles()
  const sequencePath = `${genomicsRoute.index()}?product=${
    productDetails.productType
  }&activeLink=${ActiveLinkType.SequenceEntry}`
  const [customCrisprSaveToSession] = useCustomCrisprSaveToSessionMutation()

  const saveToSession = async (data) => {
    await customCrisprSaveToSession({
      variables: { input: data, productInput: productDetails },
    })
  }
  const [getCrisprPriceCall, { data, loading: priceload }] =
    useGetCrisprPriceCallLazyQuery({
      fetchPolicy: 'network-only',
    })
  const fetchPriceData = async (obj: ConfiguratorProductInput) => {
    //check if emptyObj there
    let isEmptyObj = false
    sessionData[0].listSubModels.forEach((listModel) => {
      if (
        sessionData[0].listSubModels.length > 1 &&
        listModel.isCurrentForm &&
        listModel.name === '' &&
        listModel.sequence === ''
      ) {
        isEmptyObj = true
      }
    })
    //remove emtpy obj
    if (isEmptyObj) {
      sessionData[0].listSubModels.splice(-1, 1)
      dispatch({
        type: 'UPDATE_CURRENT_INDEX',
        data: currentSubModelIndex - 1,
      })
    }
    if (!isEmptyObj) {
      sessionData[0].listSubModels[currentSubModelIndex].isCurrentForm = false
    }
    await saveToSession(sessionData)
    await getCrisprPriceCall({
      variables: { product: obj },
    })
  }

  React.useEffect(() => {
    fetchPriceData(productDetails)
    window.scrollTo(0, 0)
  }, [])

  const intitalSessionData = () => {
    return [
      {
        id: 1,
        isOverridden: false,
        productType: 'customcrispr',
        terms: false,
        listSubModels: [
          {
            name: '',
            geneId: '',
            geneSymbol: '',
            sequence: '',
            id: 1,
            isOverridden: false,
            baseCount: 0,
            isCurrentForm: true,
            listSubModelErrors: [],
            price: '',
            cartId: '',
            itemId: '',
          },
        ],
        physicalMaterial: '',
        vector: 'LV01',
        viralTiter: '10^6',
        volume: '0.2',
        aliquoting: '1 x 200',
        amount: '1',
        lentiviralBackbone: 'LV01',
        format: 'DRY',
        pageNo: 0,
        purification: '',
        structure: '',
        modification: '',
        scale: '',
        species: '',
        listVectors: [''],
        listAmount: [''],
        listLentiviralBackbones: [''],
        listViralTiters: [''],
        listVolumes: [''],
        listAliquotings: [''],
        listPurification: [''],
        listSpecies: [''],
        listScale: [''],
        listModification: [''],
        listStructure: [''],
        listPhysicalMaterials: [],
        price: '',
        currencySymbol: '',
        currency: '',
        material: '',
        modifiedSequence: '',
        modifiedTechnicalSequence: '',
      },
    ]
  }

  const deleteOligoItem = (item, type) => {
    if (type === 'Selected' || type === 'SelectedViewAll') {
      if (currentSubModelIndex !== 1) {
        const array = [...state.sessionData[0].listSubModels]
        const index = array.indexOf(item)
        if (index !== -1) {
          array.splice(index, 1)
        }
        sessionData[0].listSubModels = array
        dispatch({
          type: 'UPDATE_CURRENT_INDEX',
          data: array.length - 1,
        })
        dispatch({
          type: 'UPDATE_LIST_SUB_MODEL',
          data: array,
        })
        dispatch({
          type: 'UPDATE_INPUT',
          data: [...sessionData],
        })
        fetchPriceData(productDetails)
      } else {
        //only one item left
        router.push(sequencePath)
        dispatch({
          type: 'CRISPR_SEQUENCE_LIST',
          data: false,
        })
        dispatch({
          type: 'UPDATE_CURRENT_INDEX',
          data: 0,
        })
        dispatch({
          type: 'UPDATE_LIST_SUB_MODEL',
          data: [],
        })
        dispatch({
          type: 'UPDATE_INPUT',
          data: intitalSessionData(),
        })
        dispatch({ type: 'SET_STEP_NO', data: 0 })
        saveToSession([])
      }
    } else if (type === 'All') {
      router.push(sequencePath)
      dispatch({
        type: 'CRISPR_SEQUENCE_LIST',
        data: false,
      })
      dispatch({
        type: 'UPDATE_CURRENT_OLIGO_INDEX',
        data: 0,
      })
      dispatch({
        type: 'UPDATE_LIST_SUB_MODEL',
        data: [],
      })
      dispatch({
        type: 'UPDATE_INPUT',
        data: intitalSessionData(),
      })
      dispatch({ type: 'SET_STEP_NO', data: 0 })
      saveToSession([])
    }
  }
  const setInitialState = () => {
    return {
      name: '',
      geneId: '',
      geneSymbol: '',
      sequence: '',
      id: customCrisprIndex,
      isOverridden: false,
      baseCount: 0,
      isCurrentForm: true,
      price: '',
      cartId: '',
      itemId: '',
    }
  }

  React.useEffect(() => {
    if (state.stepNo === 2) {
      window.scrollTo(0, 0)
    } else {
      router.push(sequencePath)
    }
    // TODO: need a test before we refactor these dependencies
  }, [])

  React.useEffect(() => {
    if (data) {
      if (!data.getCrisprPriceCall?.serverError) {
        dispatch({
          type: 'SET_PAGE_ERROR',
          data: '',
        })
        if (data.getCrisprPriceCall?.response) {
          let isEmptyObj = false
          const priceCallResponse = data.getCrisprPriceCall?.response[0]
          const listSubModels = priceCallResponse?.listSubModels
          if (listSubModels) {
            const listSubmodelPrice = listSubModels[0]?.price
            sessionData[0].listSubModels.forEach((listSubmodel) => {
              if (listSubmodelPrice) {
                listSubmodel.price = listSubmodelPrice
              }
              if (
                sessionData[0].listSubModels.length > 1 &&
                listSubmodel.isCurrentForm &&
                listSubmodel.name === '' &&
                listSubmodel.sequence === ''
              ) {
                isEmptyObj = true
              }
            })
          }
          sessionData[0].price = priceCallResponse?.price
          sessionData[0].currencySymbol = priceCallResponse?.currencySymbol
          sessionData[0].currency = priceCallResponse?.currency
          if (!isEmptyObj) {
            const emptyStateObj = Object.assign({}, setInitialState())
            if (sessionData[0] && sessionData[0].listSubModels) {
              sessionData[0].listSubModels.push(emptyStateObj)
            }
            dispatch({
              type: 'UPDATE_CURRENT_INDEX',
              data: sessionData[0].listSubModels.length - 1,
            })
          }
          dispatch({
            type: 'UPDATE_INPUT',
            data: [...state.sessionData],
          })
          saveToSession(sessionData)
        }
      } else {
        dispatch({
          type: 'SET_PAGE_ERROR',
          data: ConfiguratorValues.InternalServerError,
        })
      }
    }
    // TODO: need a test before we refactor these dependencies
  }, [data])

  const addProductFromConfirm = () => {
    router.push(sequencePath)
    dispatch({
      type: 'UPDATE_LIST_SUB_MODEL',
      data: sessionData[0].listSubModels,
    })
    dispatch({
      type: 'UPDATE_INPUT',
      data: [...sessionData],
    })
    saveToSession(sessionData)
  }
  const displaySessionData = (item: ListSubModel, index: number) => {
    setDialogOpen(true)
    setViewItem(item)
    setViewItemIndex(index)
  }

  const tableColumns = [
    {
      headElement: (
        <div>
          <FormattedMessage {...messages.NAME} />
        </div>
      ),
      bodyElement: (row, index) => (
        <div>
          <ButtonBase
            id="customCrispr-table-name-link"
            className={globalClasses.nameLink}
            onClick={() => displaySessionData(row, index)}
          >
            {row.name}
          </ButtonBase>
        </div>
      ),
    },
    {
      headElement: (
        <>
          <FormattedMessage {...messages.CONF_SEQUENCE_LABEL} /> &nbsp;
          <FormattedMessage {...messages.CONF_SEQUENCE_TYPE} />
        </>
      ),
      bodyElement: (row) => row.sequence,
    },
    {
      headElement: <FormattedMessage {...messages.CONF_BASES_HASH} />,
      bodyElement: (row) => row.baseCount || '--',
      textAlign: 'right' as const,
    },

    {
      headElement: <FormattedMessage {...messages.GENE_ID} />,
      bodyElement: (row) => row.geneId || '--',
    },
    {
      headElement: <FormattedMessage {...messages.GENE_SYMBOL} />,
      bodyElement: (row) => row.geneSymbol || '--',
    },
    {
      headElement: <FormattedMessage {...messages.CONF_PRICE} />,
      bodyElement: () =>
        sessionData[0].listSubModels[0].price
          ? sessionData[0].listSubModels[0].price === GenomicsProperties.Quote
            ? GenomicsProperties.QuoteItem
            : priceFormatter(
                sessionData[0].listSubModels[0].price,
                currencyFormat,
                thousandSeparator,
                thousandSpacing,
                decimalSeparator,
                prefixCurrecny,
                sessionData[0].currencySymbol
              )
          : '--',
      textAlign: 'right' as const,
    },

    {
      headElement: <FormattedMessage {...messages.DELETE} />,
      bodyElement: (row) => (
        <IconButton
          id="customCrispr-delete-close-icon"
          aria-label="delete"
          className={globalClasses.deleteButtonCss}
          onClick={() => {
            handleDelete(row)
          }}
        >
          <ClearIcon className={globalClasses.clearIcon} />
        </IconButton>
      ),
      textAlign: 'center' as const,
    },
  ]

  return (
    <>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="baseline"
        className={globalClasses.titleContainer}
      >
        <Grid item xs="auto" className={globalClasses.titleText}>
          <FormattedMessage {...messages.CONF_CONFIRM_ORDER_DNA_PLATES} />
        </Grid>
        <Grid item xs="auto">
          <PerformanceGuaranteeModal />
        </Grid>
      </Grid>
      <Grid
        container
        direction="row"
        justifyContent="flex-end"
        alignItems="baseline"
        className={globalClasses.deleteContainer}
      >
        {state.sessionData[0].listSubModels.length && (
          <Link
            id="customCrispr-deleteAll-link"
            className={globalClasses.deleteButton}
            onClick={() => {
              setDelDialogOpen(true)
              setDelType('All')
              setDelItem(delItem)
            }}
          >
            <FormattedMessage {...messages.CONF_DELETE_ALL_BUTTON} />
          </Link>
        )}
      </Grid>
      <DataTable
        data={state.sessionData[0].listSubModels}
        columns={tableColumns}
        noDataComponent={
          <div>
            <FormattedMessage {...messages.SEQUENCE_LIST_EMPTY} />
          </div>
        }
      />
      <Grid
        container
        direction="row"
        justifyContent="flex-end"
        alignItems="baseline"
        className={globalClasses.addItemButtonContainer}
      >
        <ButtonBase
          id="customCrispr-add-button"
          onClick={addProductFromConfirm}
          className={globalClasses.addItemButton}
        >
          <AddIcon />
          <FormattedMessage
            {...messages.CONF_ADD_OLIGO_SIDE_BAR_customcrispr}
          />
        </ButtonBase>
      </Grid>
      <DeleteDialog
        dialogOpen={delDialogOpen}
        setDialogOpen={setDelDialogOpen}
        selectedItem={delItem}
        type={delType}
        onDelete={deleteOligoItem}
      />
      {dialogOpen ? (
        <ViewCrisprItem
          dialogOpen={dialogOpen}
          setDialogOpen={setDialogOpen}
          selectedItem={viewItem}
          selectedItemIndex={viewItemIndex}
          productDetails={productDetails}
          isSequenceEntryPage={false}
        />
      ) : (
        ''
      )}
      {priceload && <CircleLoader />}
    </>
  )
}

export default ConfirmOrderTable
